


























import { Component, Prop } from "vue-property-decorator";
import DataTable from "@/shared/components/data-table.vue";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";
import { ConsultoresService } from "@/services/consultores.service";
import { date, dateTime, timeFromNow } from "@/shared/filters";
import HistoricoAtendimentos from "./HistoricoAtendimentos.vue";

@Component({
  components: {
    DataTable,
    HistoricoAtendimentos,
  },
  filters: { date, dateTime, timeFromNow },
})
export default class Atendimentos extends mixins(GlobalMixin) {
  @Prop() idConsultor!: number;
  promiseAtendimentos: Promise<any[]> | null = null;
  loading = false;

  headersAtendimentos = [
    { value: "idAtendimento", text: "Número" },
    { value: "tipoAtendimento.descricao", text: "Tipo" },
    { value: "descricao", text: "Descrição" },
    { value: "dataAtendimento", text: "Data atendimento" },
    { value: "aberto", text: "Status" },
    { value: "quantidadeChamada", text: "Qtd. Chamadas" },
    { value: "usuario.nome", text: "Responsável" },
  ];

  mounted() {
    this.fetchAtendimentos();
  }

  async fetchAtendimentos() {
    this.loading = true;
    try {
      this.promiseAtendimentos = await ConsultoresService.ListarAtendimentos(
        this.idConsultor,
        100
      );
    } finally {
      this.loading = false;
    }
  }
}
